import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { Button, SimpleText, Modal } from 'platform-components';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { ClassNameEditorControl } from 'common.components/class-name-editor/class-name-editor';
import { getLetterErrorMessage, getNumberErrorMessage } from 'common.components/class-name-editor/utils';
import { getLetter, getNumber, getNameSettingStatus } from 'common.components/classes/selectors';
import { ClassesState } from 'common.components/classes/typings';
import { getTeamIdFromPath } from 'utils/path';

import './class__name-editor.scss';
import { getIsCollegeTeamUtil } from 'common.components/user/utils';

interface OwnProps {
    onRequestSave: (param: { letter: string | null; number: number | null }) => void;
}
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = OwnProps & StateProps;

// TODO: при рефакторинге понять, зачем тут отдельный компонент, почему не в modal выше
export const ClassNameEditorComponent = (props: Props) => {
    const { letter, number, nameSettingStatus, onRequestSave } = props;
    const [stateLetter, setStateLetter] = useState(letter);
    const [stateNumber, setStateNumber] = useState(number);

    useEffect(() => {
        setStateLetter(letter);
        setStateNumber(number);
    }, [letter, number]);

    const changeNumber = (newNumber: number) => {
        setStateNumber(newNumber);
    };

    const changeLetter = (newLetter: string) => {
        setStateLetter(newLetter);
    };

    const handleSaveButtonClick = () => {
        onRequestSave({ letter: stateLetter, number: stateNumber });
    };

    const loading = nameSettingStatus === LOADING_STATUSES.LOADING;
    const isCollegeTeam = getIsCollegeTeamUtil(number);

    return (
        <>
            <Modal.Content>
                <ClassNameEditorControl
                    isCollegeTeam={isCollegeTeam}
                    letter={stateLetter}
                    mix="class__name-editor-controls"
                    nameSettingStatus={nameSettingStatus}
                    number={stateNumber}
                    onLetterChange={changeLetter}
                    onNumberChange={changeNumber}
                />
            </Modal.Content>
            <Modal.Footer>
                <Button
                    className="class__save-button"
                    disabled={Boolean(getNumberErrorMessage(stateNumber) || getLetterErrorMessage(stateLetter))}
                    onClick={handleSaveButtonClick}
                    progress={loading}
                >
                    <SimpleText id="class.saveButton" />
                </Button>
            </Modal.Footer>
        </>
    );
};

const mapStateToProps = <T extends ClassesState>(storeState: T) => {
    const classId = getTeamIdFromPath();

    return {
        letter: getLetter(storeState, { classId }),
        number: getNumber(storeState, { classId }),
        nameSettingStatus: getNameSettingStatus(storeState, { classId }),
    };
};

export const ClassNameEditor = connect(mapStateToProps)(ClassNameEditorComponent);
